// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GsgB","left":"styles_left__2x_yz"};